module.exports = {
    IMMEDIATE_TRANSFER_PRODUCT_ALIAS: 'transferencia_inmediata'
};